import { useEffect } from 'react';

export const useStatistics = (shouldInvoke = true) => {
  useEffect(() => {
    if (!shouldInvoke) return;

    const controller = new AbortController();

    const firstInteraction = () => {
      const script = document.createElement('script');
      script.src = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/statistics`;
      script.id = 'sst';
      document.body.appendChild(script);

      controller.abort();
    };

    ['click', 'scroll', 'mousemove', 'touchstart'].forEach(function (e) {
      window.addEventListener(e, firstInteraction, {
        once: true,
        passive: true,
        signal: controller.signal,
      });
    });

    return () => {
      controller.abort();
    };
  }, []);

  return () => {
    const script = document.createElement('script');
    script.src = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/statistics`;
    script.id = 'sst';
    document.body.appendChild(script);
  };
};
